import Button from '@/components/input/Button';
import React from 'react';
import { QuestionType, Response } from '../../common';
import { enqueueSnackbar } from 'notistack';

interface Props {
  questionsLength: number;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  onFinishQuiz?: () => void;
  onExitQuiz?: () => void;
  handleSaveUserResponses?: () => void;
  response?: Response['answer'];
  questionType?: QuestionType;
}

const StepperButtons: React.FC<Props> = ({
  questionsLength,
  step,
  response,
  questionType,
  setStep,
  onFinishQuiz,
  onExitQuiz,
  handleSaveUserResponses,
}) => {
  const hasValidResponse = questionType === 'text' || response !== undefined;

  const handleBackQuestion = () => {
    if (step === 0) {
      return onExitQuiz?.();
    }
    setStep((prevStep) => prevStep - 1);
  };

  const handleNextQuestion = () => {
    if (!hasValidResponse) {
      return enqueueSnackbar({
        message: 'Debes completar la pregunta antes de continuar',
        variant: 'warning',
      })
    };
    handleSaveUserResponses?.();
    if (step === questionsLength - 1) {
      return onFinishQuiz?.();
    }
    setStep((prevStep) => prevStep + 1);
  };

  return (
    <div style={{ display: 'flex', gap: 16, justifyContent: 'flex-end' }}>
      <Button type="button" variant="outline" onClick={handleBackQuestion}>
        {step === 0 ? 'Salir del cuestionario' : 'Regresar'}
      </Button>
      <Button type="submit" sx={{ flex: 1 }} variant="main" onClick={handleNextQuestion}>
        {step === questionsLength - 1 ? 'Finalizar' : 'Siguiente'}
      </Button>
    </div>
  );
};

export default StepperButtons;
